import React from "react"
import { toMoney } from "../../../utils/string_utils"
import * as classnames from "classnames"

import "./show-pick.scss"

const SinglePick = ({
  storeName,
  deviceName,
  downloadSpeed,
  downloadSpeedUnit,
  contractLength,
  planName,
  lineRental,
  data,
  network,
  minutes,
  texts,
  speedDescription,
  speed,
  planCost,
  excludeVAT,
  vatDivider,
  extras,
  benefits,
  entertainment,
  monthlyCost,
  totalCost,
  entertainmentCost,
  upfrontCost
}) => {
  let friendlyStoreName
  switch (storeName) {
    case "BT_Acquisition_FTTC":
    case "BT_Acquisition_FTTP":
    case "BT_Retention_FTTC":
    case "BT_Retention_FTTP":
      friendlyStoreName = "BT"
      break
    case "Sky_Acquisition_FTTC":
    case "Sky_Acquisition_FTTP":
    case "Sky_Retention_FTTC":
    case "Sky_Retention_FTTP":
      friendlyStoreName = "Sky"
      break
    case "Vodafone_Acquisition_FTTC":
    case "Vodafone_Acquisition_FTTP":
    case "Vodafone_Retention_FTTC":
    case "Vodafone_Retention_FTTP":
      friendlyStoreName = "Vodafone"
      break
    case "Virgin_Acquisition_FTTC":
    case "Virgin_Acquisition_FTTP":
    case "Virgin_Retention_FTTC":
    case "Virgin_Retention_FTTP":
      friendlyStoreName = "Virgin Media"
      break
    default:
      throw Error("No Storename mapping to device!!!")
  }

  return (
    <div
      className={classnames(
        "pickedContainer",
        { "bt-store": storeName === "BT_Acquisition_FTTC" },
        { "bt-store": storeName === "BT_Acquisition_FTTP" },
        { "bt-store": storeName === "BT_Retention_FTTC" },
        { "bt-store": storeName === "BT_Retention_FTTP" },
        {
          "vodafone-store": storeName === "Vodafone_Acquisition_FTTC"
        },
        {
          "vodafone-store": storeName === "Vodafone_Acquisition_FTTP"
        },
        {
          "vodafone-store": storeName === "Vodafone_Retention_FTTC"
        },
        {
          "vodafone-store": storeName === "Vodafone_Retention_FTTP"
        },
        {
          "virgin-store": storeName === "Virgin_Acquisition_FTTC"
        },
        {
          "virgin-store": storeName === "Virgin_Acquisition_FTTP"
        },
        {
          "virgin-store": storeName === "Virgin_Retention_FTTC"
        },
        {
          "virgin-store": storeName === "Virgin_Retention_FTTP"
        },
        {
          "sky-store": storeName === "Sky_Acquisition_FTTC"
        },
        {
          "sky-store": storeName === "Sky_Acquisition_FTTP"
        },
        {
          "sky-store": storeName === "Sky_Retention_FTTC"
        },
        {
          "sky-store": storeName === "Sky_Retention_FTTP"
        }
      )}
    >
      <div className="entry">
        <div className="pageBanner">
          <div className="description">
            <div className="storeLogo" />
            &nbsp;
            <div className="storeTitle">{friendlyStoreName}</div>
          </div>
        </div>
      </div>
      {/* <div className="entry">
        <span className="pickedLabel">Router: </span>
        {deviceName}
      </div> */}
      <div className="entry">
        <p className="pickedLabel">Plan: </p>
        <p className="data">{planName}</p>
        <p className="data">
          {downloadSpeed}
          {downloadSpeedUnit} download speed
        </p>
        <p className="data">{lineRental}</p>
        <p className="data">{contractLength} month contract</p>
        {/* <p className="data">{`${data} ${network} data`}</p>
        <p className="data">{minutes} minutes</p>
        <p className="data">{texts} texts</p> */}
        {speedDescription && <p className="data">{speedDescription}</p>}
        {speed && <p className="data">{speed}</p>}
        {planCost.airtime && (
          <p>
            <span className="pickedLabel">Airtime plan:</span>{" "}
            {excludeVAT ? (
              <>
                {toMoney(planCost.airtime / vatDivider, "£")}{" "}
                <span className="vatDescription">(exc. VAT)</span>
              </>
            ) : (
              toMoney(planCost.airtime, "£")
            )}
          </p>
        )}
        {planCost.handset && (
          <p>
            <span className="pickedLabel">Monthly device cost:</span>{" "}
            {excludeVAT ? (
              <>
                {toMoney(planCost.handset / vatDivider, "£")}{" "}
                <span className="vatDescription">(exc. VAT)</span>
              </>
            ) : (
              toMoney(planCost.handset, "£")
            )}
          </p>
        )}
      </div>
      {extras && extras.length > 0 && extras[0] !== "" && (
        <div className="entry">
          {extras.map((extra, index) => (
            <p key={`extra_${index + 1}`}>
              <span className="pickedLabel">Extra - </span>
              {extra}
            </p>
          ))}
        </div>
      )}
      {benefits && benefits.length > 0 && benefits[0] !== "" && (
        <div className="entry">
          {benefits.map((benefit, index) => (
            <p key={`benefit_${index + 1}`}>
              <span className="pickedLabel">Benefit - </span>
              {benefit}
            </p>
          ))}
        </div>
      )}
      {entertainment === 1 && (
        <div className="entry">
          <p>
            <span className="pickedLabel">Entertainment: </span>
            {toMoney(entertainmentCost)}
          </p>
        </div>
      )}
      <div className="entry">
        {!!monthlyCost && (
          <>
            {!!excludeVAT && (
              <p>
                <span className="pickedLabel">
                  Total monthly VAT ({Math.round((vatDivider - 1) * 100)}
                  %):
                </span>{" "}
                {toMoney(totalCost.maf - totalCost.maf / vatDivider, "£")}
              </p>
            )}
            <p>
              <span className="pickedLabel">Total monthly cost: </span>
              {excludeVAT ? (
                <>
                  {toMoney(monthlyCost, "£")}{" "}
                  <span className="vatDescription">
                    (
                    {toMoney(
                      (monthlyCost + entertainmentCost) / vatDivider,
                      "£"
                    )}{" "}
                    exc. VAT)
                  </span>
                </>
              ) : (
                toMoney(monthlyCost + entertainmentCost, "£")
              )}
            </p>
          </>
        )}
        {!!upfrontCost && (
          <p>
            <span className="pickedLabel">Total upfront cost: </span>
            {excludeVAT ? (
              <>
                {toMoney(upfrontCost, "£")}{" "}
                <span className="vatDescription">
                  ({toMoney(upfrontCost / vatDivider, "£")} exc. VAT)
                </span>
              </>
            ) : (
              toMoney(upfrontCost, "£")
            )}
          </p>
        )}
      </div>
    </div>
  )
}

export default SinglePick
